export enum ErrorContext {
    BETA_UITLEG = 'betaUitleg',
    GENERIEK = 'generiek',
    NIET_GEVONDEN = 'nietGevonden',
    ZAKELIJK_GEBLOKKEERD = 'zakelijkGeblokkeerd'
}
